export const FRAMER_TRANSITION_EASEOUT = {
  delay: 0.2,
  duration: 0.9,
  type: 'tween',
  ease: 'easeOut',
}

export const FRAMER_PAGE_TRANSITION_DURATION = 1

export const FRAMER_PAGE_TRANSITION = {
  duration: FRAMER_PAGE_TRANSITION_DURATION,
  type: 'tween',
  ease: 'easeOut',
}

export const FRAMER_TRANSITION_FASTEASE = {
  delay: 0,
  duration: 0.5,
  type: 'tween',
  ease: 'easeInOut',
}

export const FRAMER_TRANSITION_FASTEREASE = {
  delay: 0,
  duration: 0.2,
  type: 'tween',
  ease: 'easeInOut',
}
export const MOBILE_VARIANTS = {
  variants: {
    active: {},
    inactive: {},
  },
}
export const FRAMER_FADEINUP = {
  variants: {
    active: { opacity: 1, y: 0 },
    inactive: { opacity: 0, y: 20 },
  },
}
export const FRAMER_SLIDEINLEFT = {
  variants: {
    active: { x: 0, opacity: 1 },
    inactive: { x: 50, opacity: 0 },
  },
}
